'use client';
import React from 'react';
import { QuoteBox } from '../QuoteBox';
import { DelayedQuote } from '@benzinga/quotes-manager';
import { StockSymbol } from '@benzinga/session';
import styles from './QuotesList.module.scss';

interface QuotesListProps {
  quotes?: Record<StockSymbol, DelayedQuote> | null;
  tickers?: string[];
}

export const QuotesList: React.FC<QuotesListProps> = ({ quotes, tickers }) => {
  const getQuote = React.useCallback(
    ticker => {
      if (quotes?.[ticker] && !quotes?.[ticker]?.error) {
        return quotes[ticker];
      }

      return null;
    },
    [quotes],
  );

  return (
    <div className={`${styles.quoteListWrapper} quote-list-wrapper`}>
      {tickers &&
        tickers?.map((ticker, i: number) => {
          return <QuoteBox key={i} quote={getQuote(ticker)} />;
        })}
    </div>
  );
};
